import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./containers/Home";
import NotFound from "./containers/NotFound";
import Login from "./containers/Login";
import Signup from "./containers/Signup";
import PublicRoute from "./utils/PublicRoute";
import PrivateRoute from "./utils/PrivateRoute";
import Dashboard from "./containers/Dashboard";
import Dashboard2 from "./containers/Dashboard2";
import Caps from "./containers/Caps";
import Camera from "./containers/Camera";
import Camera2 from "./containers/Camera2";
import Events from "./containers/Events";
import NewEvent from "./containers/NewEvent";
import Replay from "./containers/Replay";
import ProjectFiles from "./containers/ProjectFiles";
import Account from "./containers/Account";
import Snapshot from "./containers/Snapshot";
import Snapshot360 from "./containers/Snapshot360";
import Replay360 from "./containers/Replay360";
import Frames from "./containers/Frames.js";
import FrameHistory from "./containers/FrameHistory.js";
import Admin from "./containers/Admin.js";
import Orders from "./containers/Orders.js";
import CapSoftware from "./containers/CapSoftware.js";
import DataDeletion from "./containers/DataDeletion.js";
import Units from "./containers/Units.js";
import UnitDetail from "./containers/UnitDetail.js";
import Sims from "./containers/Sims.js";
import Zones from "./containers/Zones.js";
// import Demo from "./containers/Demo.js";
import Activate from "./containers/Activate.js";
import SignupNewCap from "./containers/SignupNewCap.js"
import Labeler from "./containers/Labeler.js"
import Reservations from "./containers/Reservations.js"
import ReadyNowReserve from "./containers/ReadyNowReserve.js"
import ReadyNowCheckout from "./containers/ReadyNowCheckout.js"
import ReadyNowSuccess from "./containers/ReadyNowSuccess.js"
import PasswordReset from "./containers/PasswordReset.js"
import AccountInfo from "./containers/AccountInfo.js";
import ChangePassword from "./containers/ChangePassword.js";
import Integrations from "./containers/Integrations.js";
import Notifications from "./containers/Notifications.js";
import Help from "./containers/Help.js";
import Unsubscribe from "./containers/Unsubscribe.js";
import Events2 from "./containers/Events2.js";
// import Test from "./containers/test.js";
import Camera3 from "./containers/Camera3.js";
// import LiveFeed from "./containers/LiveFeed.js";
// import Payment from "./containers/Payment.js"
import AccessControl from "./containers/AccessControl.js";
import UserAccessDetail from "./containers/UserAccessDetail.js";
import CameraManagement from "./containers/CameraManagement";
import CameraSettings from "./containers/CameraSettings";
import TimelapseList from "./containers/TimelapseList";

export default function Routes({ appProps }) {
  return (
    <Switch>
      <Route exact path="/" component={Home} appProps={appProps} />
      {/* <Route exact path="/test" component={Demo} appProps={appProps} /> */}
      <PublicRoute path="/login" exact component={Login} appProps={appProps} />
      <PublicRoute path="/signup" exact component={Signup} appProps={appProps} />
      <PublicRoute path="/passwordreset" exact component={PasswordReset} appProps={appProps} />
      <PublicRoute path="/passwordreset/:resetkey" exact component={PasswordReset} appProps={appProps} />
      <PublicRoute path="/unsubscribe/:userid" exact component={Unsubscribe} appProps={appProps} />
      {/* hash may be a query param (?hash=) or a legacy path segment */}
      <PublicRoute path="/activate/:userid/:capid/:hash?" exact component={Activate} appProps={appProps} />
      <PrivateRoute path="/account" exact component={Account} appProps={appProps} />
      <PrivateRoute path="/admin" exact component={Admin} appProps={appProps} />
      <PrivateRoute path="/admin/orders" exact component={Orders} appProps={appProps} />
      <PrivateRoute path="/admin/cap-software" exact component={CapSoftware} appProps={appProps} />
      <PrivateRoute path="/admin/data-deletion" exact component={DataDeletion} appProps={appProps} />
      <PrivateRoute path="/admin/units" exact component={Units} appProps={appProps} />
      <PrivateRoute path="/admin/units/:unitId" exact component={UnitDetail} appProps={appProps} />
      <PrivateRoute path="/admin/sims" exact component={Sims} appProps={appProps} />
      <PrivateRoute path="/dashboardOld" exact component={Dashboard} appProps={appProps} />
      <PrivateRoute path="/dashboard" exact component={Dashboard2} appProps={appProps} />
      <PrivateRoute path="/caps/:capid" exact component={Caps} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/cameras/:monitorid" exact component={Camera} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/camera/:monitorid" exact component={Camera2} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/camera/:monitorid/stream/:view" exact component={Camera3} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/events2" exact component={Events} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/events" exact component={Events2} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/events/new" exact component={NewEvent} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/events/:eventid" exact component={Replay} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/files" exact component={ProjectFiles} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/events/:eventid/snapshot" exact component={Snapshot} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/360events/:captureid/" exact component={Replay360} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/360events/:captureid/:eventid" exact component={Replay360} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/360events/:captureid/snapshot" exact component={Snapshot360} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/frames" exact component={Frames} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/frames/:captureid" exact component={FrameHistory} appProps={appProps} />
      <PrivateRoute path="/frames/:captureid" exact component={FrameHistory} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/zones" exact component={Zones} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/settings" exact component={CameraSettings} appProps={appProps} />
      <PrivateRoute path="/events/:eventid" exact component={Replay} appProps={appProps} />
      <PrivateRoute path="/signupnewcap" exact component={SignupNewCap} appProps={appProps} />
      <PrivateRoute path="/signupnewcap/:capId" exact component={SignupNewCap} appProps={appProps} />
      <PrivateRoute path="/labels" exact component={Labeler} appProps={appProps} />
      <PrivateRoute path="/labels/:imageid" exact component={Labeler} appProps={appProps} />
      <PrivateRoute path="/labels/user/:userid" exact component={Labeler} appProps={appProps} />
      <PrivateRoute path="/reserve" exact component={Reservations} appProps={appProps} />
      <PrivateRoute path="/reserve/ready" exact component={ReadyNowReserve} appProps={appProps} />
      <PrivateRoute path="/reserve/ready/checkout" exact component={ReadyNowCheckout} appProps={appProps} />
      <PrivateRoute path="/reserve/ready/success" exact component={ReadyNowSuccess} appProps={appProps} />
      {/* <PrivateRoute path="/account/:submenu" exact component={Account} appProps={appProps} /> */}
      {/* <PrivateRoute path="/account/:submenu/:notificationsmenu" exact component={Account} appProps={appProps} /> */}
      <PrivateRoute path="/account/info" exact component={AccountInfo} appProps={appProps} />
      <PrivateRoute path="/account/password" exact component={ChangePassword} appProps={appProps} />
      <PrivateRoute path="/account/integrations" exact component={Integrations} appProps={appProps} />
      <PrivateRoute path="/account/notifications" exact component={Notifications} appProps={appProps} />
      <PrivateRoute path="/account/notifications/:tab" exact component={Notifications} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/events/:eventid/notification/:notificationid" exact component={Replay} appProps={appProps} />
      <PrivateRoute path="/caps/:capid/events/notification/:notificationid" exact component={Events2} appProps={appProps} />
      <PrivateRoute path="/help" exact component={Help} appProps={appProps} />
      <PrivateRoute path="/help/:helpkey" exact component={Help} appProps={appProps} />
      <PrivateRoute path="/accesscontrol/:builderid" exact component={AccessControl} appProps={appProps} />
      <PrivateRoute path="/accesscontrol/:builderid/user/:userid" exact component={UserAccessDetail} appProps={appProps} />
      <PrivateRoute path="/cameramanagement/:builderid" exact component={CameraManagement} appProps={appProps} />
      {/* <PrivateRoute path="/test/stream" exact component={Test} /> */}
      {/* <PrivateRoute path="/livefeed/:capid" exact component={LiveFeed} appProps={appProps} /> */}
      {/* <PublicRoute path="/payment" exact component={Payment} appProps={appProps} /> */}
      {/* <PrivateRoute path="/caps/:capid/cameras/:monitorid/:smallid" exact component={Camera} appProps={appProps} /> */}
      <PrivateRoute path="/cameramanagement/:builderid" exact component={CameraManagement} appProps={appProps} />
      <PrivateRoute path="/timelapse/:builderid" exact component={TimelapseList} appProps={appProps} />
      { /* Finally, catch all unmatched routes */ }
      <Route component={NotFound} />
    </Switch>
  );
}